import { BadgeColorPalette, BadgeStatusSubvariantEnum, BadgeVariantEnum } from '@app/types/badge';
import { palette } from '@app/theme/palette';

export const badgeColorPalette: BadgeColorPalette = {
  [BadgeVariantEnum.STATUS]: {
    [BadgeStatusSubvariantEnum.APPROVED]: {
      bgHexColor: palette.collection.green.d850,
      bgOpacity: 0.5,
    },
    [BadgeStatusSubvariantEnum.EXPIRED]: {
      bgHexColor: palette.collection.yellow.d250,
      bgOpacity: 0.5,
    },
    [BadgeStatusSubvariantEnum.PENDING]: {
      bgHexColor: palette.collection.blue.d400,
      bgOpacity: 0.5,
    },
    [BadgeStatusSubvariantEnum.IN_REVIEW]: {
      bgHexColor: palette.collection.blue.d450,
      bgOpacity: 0.5,
    },
    [BadgeStatusSubvariantEnum.REJECTED]: {
      bgHexColor: palette.collection.red.d550,
      bgOpacity: 0.5,
    },
  },
};
